export const Z_INDEX = {
  DROPDOWN_LAYER: 999,
} as const;
